class UniversalService {
    axios;
    constructor(axios) {
        this.axios = axios;
    }
    adminPortal = {
        rfp: {
            create: async (input) => {
                const { data } = await this.axios.mainInstance.post(`/product/sourgum-internal/rfp`, input);
                return data;
            },
            fetch: async (id) => {
                const { data } = await this.axios.mainInstance.get(`/product/sourgum-internal/rfp/${id}`);
                return data;
            },
            query: async (query) => {
                const { data } = await this.axios.mainInstance.get(`/product/sourgum-internal/rfp`, {
                    params: query,
                });
                return data;
            },
            update: async (id, input) => {
                const { data } = await this.axios.mainInstance.patch(`/product/sourgum-internal/rfp/${id}`, input);
                return data;
            },
            delete: async (id) => {
                const { data } = await this.axios.mainInstance.delete(`/product/sourgum-internal/rfp/${id}`);
                return data;
            },
        },
        rfpVendorResponse: {
            create: async (input) => {
                const { data } = await this.axios.mainInstance.post(`/product/sourgum-internal/rfp-vendor-response`, input);
                return data;
            },
            fetch: async (id) => {
                const { data } = await this.axios.mainInstance.get(`/product/sourgum-internal/rfp-vendor-response/${id}`);
                return data;
            },
            query: async (query) => {
                const { data } = await this.axios.mainInstance.get(`/product/sourgum-internal/rfp-vendor-response`, {
                    params: query,
                });
                return data;
            },
            update: async (id, input) => {
                const { data } = await this.axios.mainInstance.patch(`/product/sourgum-internal/rfp-vendor-response/${id}`, input);
                return data;
            },
            delete: async (id) => {
                const { data } = await this.axios.mainInstance.delete(`/product/sourgum-internal/rfp-vendor-response/${id}`);
                return data;
            },
        },
        serviceOrder: {
            query: async (query) => {
                const { data } = await this.axios.mainInstance.get(`/product/service-order`, {
                    params: query,
                });
                return data;
            },
        },
    };
    wayste = {
        rfpVendorResponse: {
            fetch: async (id) => {
                const { data } = await this.axios.mainInstance.get(`/product/wayste/rfp-vendor-response/${id}`);
                return data;
            },
            query: async (query) => {
                const { data } = await this.axios.mainInstance.get(`/product/wayste/rfp-vendor-response`, {
                    params: query,
                });
                return data;
            },
            update: async (id, input) => {
                const { data } = await this.axios.mainInstance.patch(`/product/wayste/rfp-vendor-response/${id}`, input);
                return data;
            },
            public: {
                fetch: async (accessLinkID) => {
                    const { data } = await this.axios.mainInstance.get(`/product/wayste/rfp-vendor-response/public/${accessLinkID}`);
                    return data;
                },
                update: async (accessLinkID, input) => {
                    const { data } = await this.axios.mainInstance.patch(`/product/wayste/rfp-vendor-response/public/${accessLinkID}`, input);
                    return data === 'success' ? 'success' : 'error';
                },
            },
        },
    };
    customerPortal = {
        fetch: async (id) => {
            const { data } = await this.axios.mainInstance.get(`/product/sourgum-customer/service-grouping/${id}`);
            return data;
        },
        query: async (query) => {
            const { data } = await this.axios.mainInstance.get(`/product/sourgum-customer/service-grouping`, {
                params: query,
            });
            return data;
        },
    };
    /**
     * @deprecated TODO move these under adminPortal
     */
    serviceGrouping = {
        query: async (query) => {
            const { data } = await this.axios.mainInstance.get(`/product/service-grouping`, {
                params: query,
            });
            return data;
        },
        fetch: async (id) => {
            const { data } = await this.axios.mainInstance.get(`/product/service-grouping/${id}`);
            return data;
        },
        fetchBulk: async (ids) => {
            const { data } = await this.axios.mainInstance.post(`/product/service-grouping/bulk`, ids);
            return data;
        },
        create: async (input) => {
            const { data } = await this.axios.mainInstance.post(`/product/service-grouping`, input);
            return data;
        },
        createRecursive: async (input) => {
            const { data } = await this.axios.mainInstance.post(`/product/service-grouping/recursive`, input);
            return data;
        },
        update: async (id, input) => {
            const { data } = await this.axios.mainInstance.put(`/product/service-grouping/${id}`, input);
            return data;
        },
        delete: async (id) => {
            const { data } = await this.axios.appAdminInstance.delete(`/product/service-grouping/${id}`);
            return data;
        },
        addNote: async (id, input) => {
            const { data } = await this.axios.mainInstance.post(`/product/service-grouping/${id}/internal-note`, input);
            return data;
        },
        serviceOrder: {
            create: async (id, input) => {
                const { data } = await this.axios.mainInstance.post(`/product/service-grouping/${id}/service-order`, input);
                return data;
            },
            delete: async (id, serviceOrderID) => {
                const { data } = await this.axios.mainInstance.delete(`/product/service-grouping/${id}/service-order/${serviceOrderID}`);
                return data;
            },
            update: async (id, serviceOrderID, input) => {
                const { data } = await this.axios.mainInstance.put(`/product/service-grouping/${id}/service-order/${serviceOrderID}`, input);
                return data;
            },
            serviceOrderEvent: {
                create: async (id, serviceOrderID, input) => {
                    const { data } = await this.axios.mainInstance.post(`/product/service-grouping/${id}/service-order/${serviceOrderID}/event`, input);
                    return data;
                },
                createMany: async (id, serviceOrderID, input) => {
                    const { data } = await this.axios.mainInstance.post(`/product/service-grouping/${id}/service-order/${serviceOrderID}/event/bulk`, input);
                    return data;
                },
                delete: async (id, serviceOrderID, eventID) => {
                    const { data } = await this.axios.mainInstance.delete(`/product/service-grouping/${id}/service-order/${serviceOrderID}/event/${eventID}`);
                    return data;
                },
            },
        },
    };
    /**
     * @deprecated TODO move these under adminPortal
     */
    serviceOrder = {
        query: async (query) => {
            const { data } = await this.axios.mainInstance.get(`/product/service-order`, {
                params: query,
            });
            return data;
        },
        fetch: async (id) => {
            const { data } = await this.axios.mainInstance.get(`/product/service-order/${id}`);
            return data;
        },
    };
    /**
     * @deprecated TODO move these under adminPortal
     */
    serviceFamily = {
        query: async (query) => {
            const { data } = await this.axios.mainInstance.get(`/product/service-type`, {
                params: query,
            });
            return data;
        },
        fetch: async (id) => {
            const { data } = await this.axios.mainInstance.get(`/product/service-type/${id}`);
            return data;
        },
        create: async (input) => {
            const { data } = await this.axios.mainInstance.post(`/product/service-type/recursive`, input);
            return data;
        },
        update: async (id, input) => {
            const { data } = await this.axios.mainInstance.put(`/product/service-type/${id}/recursive`, input);
            return data;
        },
        deleteStatus: async (id, input) => {
            const { data } = await this.axios.mainInstance.put(`/product/service-type/${id}/allowed-statuses`, input);
            return data;
        },
        lineItemType: {
            create: async (serviceTypeID, input) => {
                const { data } = await this.axios.mainInstance.post(`/product/service-type/${serviceTypeID}/line-item-type`, input);
                return data;
            },
            update: async (serviceTypeID, lineItemTypeID, input) => {
                const { data } = await this.axios.mainInstance.put(`/product/service-type/${serviceTypeID}/line-item-type/${lineItemTypeID}`, input);
                return data;
            },
        },
    };
    /**
     * @deprecated TODO move these under adminPortal
     */
    serviceType = {
        fetch: async (serviceFamilyID, serviceTypeID) => {
            const { data } = await this.axios.mainInstance.get(`/product/service-type/${serviceFamilyID}/service-type/${serviceTypeID}`);
            return data;
        },
        update: async (serviceFamilyID, serviceTypeID, input) => {
            const { data } = await this.axios.mainInstance.put(`/product/service-type/${serviceFamilyID}/service-type/${serviceTypeID}`, input);
            return data;
        },
    };
    /**
     * @deprecated TODO move these under adminPortal
     */
    invoice = {
        query: async (query) => {
            const { data } = await this.axios.mainInstance.get(`/product/invoice-grouping`, {
                params: query,
            });
            return data;
        },
        fetch: async (id) => {
            const { data } = await this.axios.mainInstance.get(`/product/invoice-grouping/${id}`);
            return data;
        },
        create: async (input) => {
            const { data } = await this.axios.mainInstance.post(`/product/invoice-grouping`, input);
            return data;
        },
        update: async (id, input) => {
            const { data } = await this.axios.mainInstance.put(`/product/invoice-grouping/${id}`, input);
            return data;
        },
        attachEvent: async (id, eventID) => {
            const { data } = await this.axios.mainInstance.post(`/product/invoice-grouping/${id}/attach-event/${eventID}`);
            return data;
        },
        detachEvent: async (id, eventID) => {
            const { data } = await this.axios.mainInstance.delete(`/product/invoice-grouping/${id}/attach-event/${eventID}`);
            return data;
        },
        queryByServiceOrderId: async (ids) => {
            const { data } = await this.axios.mainInstance.post(`/product/invoice-grouping/find-by-service-order`, {
                serviceOrderIDs: ids,
            });
            return data;
        },
    };
    /////////////////////////// SERVICE AREAS FOR UNIVERSAL SERVICES ///////////////////////////
    /**
     * @deprecated TODO move these under adminPortal
     */
    pricingZone = {
        query: async (query) => {
            const { data } = await this.axios.mainInstance.get(`/pricing/product`, {
                params: query,
            });
            return data;
        },
        fetch: async (id) => {
            const { data } = await this.axios.mainInstance.get(`/pricing/product/${id}`);
            return data;
        },
        create: async (input) => {
            const { data } = await this.axios.mainInstance.post(`/pricing/product`, input);
            return data;
        },
        update: async (id, input) => {
            const { data } = await this.axios.mainInstance.patch(`/pricing/product/${id}`, input);
            return data;
        },
        // UPDATE EXISTING SERVICE AREA
        updateServiceArea: async (id, input) => {
            const { data } = await this.axios.mainInstance.put(`/pricing/product/${id}/service-area`, input);
            return data;
        },
    };
}
export default UniversalService;
//# sourceMappingURL=Universal.service.js.map